// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.faq-modal {
  width: var(--faq-modal-width-tablet) !important;
}
@media (min-width: 1200px) {
  .faq-modal {
    width: var(--faq-modal-width-desktop) !important;
  }
}
.faq-modal .content .collapse .ant-collapse-header {
  font-size: 1rem;
  font-weight: bold;
  padding-right: 2rem;
}
.faq-modal .content .collapse .ant-collapse-item {
  border-bottom: 1px solid rgb(238, 238, 238);
}`, "",{"version":3,"sources":["webpack://./src/components/modals/FAQModal/FAQModal.scss"],"names":[],"mappings":"AAEA;EACI,+CAAA;AADJ;AAGI;EAHJ;IAIQ,gDAAA;EAAN;AACF;AAIY;EACI,eAAA;EACA,iBAAA;EACA,mBAAA;AAFhB;AAKY;EACI,2CAAA;AAHhB","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
